export default {
  page_title: '違反単語',
  word: '単語',
  entity: '違反単語制作'
};
